import { render, staticRenderFns } from "./AjudaMensagemConfirmacaoModal.vue?vue&type=template&id=31a6a94a&scoped=true"
import script from "./AjudaMensagemConfirmacaoModal.vue?vue&type=script&lang=ts"
export * from "./AjudaMensagemConfirmacaoModal.vue?vue&type=script&lang=ts"
import style0 from "./AjudaMensagemConfirmacaoModal.vue?vue&type=style&index=0&id=31a6a94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a6a94a",
  null
  
)

export default component.exports